export const NUMBER_EXIST = `
query($phoneNumber:String){
    usersConnection(where:{phoneNumber:$phoneNumber}){
      aggregate{
        count
      }
    }
  }
`;

export const SEND_VERIFICATION = `
query($email: String) {
  sendVerificationCode(email: $email) {
    token
    status
  }
}
`;
